import React, { useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import * as d3 from 'd3';

const CameraEntityDrawer = ({ entityDetails, chartRef }) => {
  // Mock live stream and incidents if not provided by entityDetails
  const liveStreamUrl = entityDetails?.name === 'CAM-091' ?  'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/0a2117bc-a7c5-5404-aa59-7f203530cd46.mp4' : 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/it_request_4_gl_first_10s.mp4';
  const livePosterUrl = entityDetails?.name === 'CAM-091' ?  'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/0a2117bc-a7c5-5404-aa59-7f203530cd46.mp4' : 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/it_request_4_gl_first_10s.mp4';

  const bbIncidentData = [

    

    {
      id: 'EVT-001',
      title: 'Graffiti Monitoring',
      severity: 'High',
      time: '2025-10-25T12:10:00Z',
      description: 'Arm movements and visual streaks suggesting they are applying paint or spray.  Based on context this likely represents graffiti creation or wall tagging behavior.',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/syth_data_grafitti_bb.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/syth_data_grafitti_bb.mp4'
    },
    {
      id: 'EVT-002',
      title: 'Bar Opening',
      severity: 'Medium',
      time: '2025-10-25T12:10:00Z',
      description: 'Bar Opening detected.',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/66a07443-098c-5147-9b86-696e02929fd5.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/66a07443-098c-5147-9b86-696e02929fd5.mp4'
    },
    {
      id: 'EVT-003',
      title: 'Maintenance Crew',
      severity: 'Low',
      time: '2025-10-25T18:20:00Z',
      description: " A green utility vehicle (likely used for maintenance or transport) is seen driving from left to right across the frame, moving away from the camera's view.\n\n4. **Traffic**:\n   - There is no visible traffic on the road in the background, indicating that the footage was taken during a time when there was little to no vehicular activity.\n\n5. **Notable Activities**:\n   - The overall scene appears calm, with minimal activity. The individuals seem to be engaged in casual interactions, possibly ordering food or drinks at the counter.\n   - The presence of the dog suggests that it might be accompanying its owner, which is common in outdoor dining areas.\n\nThe footage captures a typical day at an outdoor dining area within a park, with minimal movement and activity.",
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/34ef9446-b9f8-58e5-ac31-6f91bcaaa911.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/34ef9446-b9f8-58e5-ac31-6f91bcaaa911.mp4'
    },

    {
      id: 'EVT-004',
      title: 'Bus Arriving',
      severity: 'Low',
      time: '2025-10-25T19:55:00Z',
      description: 'Bus arriving on the backdrop of the bark park. Waiting for passengers to board. .',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_bus_arriving_20s_to_40s.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_bus_arriving_20s_to_40s.mp4'
    },
    {
      id: 'EVT-005',
      title: 'Bus Leaving',
      severity: 'Low',
      time: '2025-10-25T19:57:00Z',
      description: 'Bus leaving the bark park. Two passengers on the bus.',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_bus_leaving_50s_to_70s.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_bus_leaving_50s_to_70s.mp4'
    },
   
    {
      id: 'EVT-005',
      title: 'Bar Closing',
      severity: 'High',
      time: '2065-10-25T03:55:00Z',
      description: 'Bar closing time, Workers appearing to be packing up and leaving.',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_closing_9m45s_to_10m.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/barkpark/bark_bar_closing_9m45s_to_10m.mp4'
    }
   
  ];

  const glIncidentData = [
    {
      id: 'EVT-001',
      title: 'View Blocked by Tree',
      severity: 'High',
      time: '2025-10-26T06:20:00Z',
      description: 'The surveillance footage shows a view blocked by a tree.',
      videoUrl:  'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/it_request_4_gl_first_10s.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/it_request_4_gl_first_10s.mp4',
    },
    {
      id: 'EVT-002',
      title: 'Sprinkler Activation',
      severity: 'Medium',
      time: '2025-10-26T06:20:00Z',
      description: 'The surveillance footage shows a nighttime scene in a park with a sprinkler system active. The sprinklers are spraying water across the grassy area, creating a misty effect as they move back and forth. There are no visible people, animals, or vehicles in the frame. The lighting is dim, primarily coming from the sprinklers themselves and some distant lights that appear to be from nearby buildings. The environment appears calm, with no significant activity occurring apart from the operation of the sprinklers.',
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/great_lawn_sprinklers_turn_on_30s_to_45s.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/great_lawn_sprinklers_turn_on_30s_to_45s.mp4'
    },
    {
      id: 'EVT-003',
      title: 'Lawn Mowing',
      severity: 'Low',
      time: '2025-10-25T06:10:00Z',
      description: "Movement of a Vehicle**: A small vehicle, possibly a lawnmower or a similar piece of equipment, appears from the left side of the frame. It moves slowly across the grassy area towards the right side of the frame. The vehicle's headlights are on, casting light on the ground as it moves.",
      videoUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/great_lawn_lawnmower_arrives_45s_to_65s.mp4',
      thumbnailUrl: 'https://smarttrafficportal.s3.us-west-2.amazonaws.com/cary/greatlawn/great_lawn_lawnmower_arrives_45s_to_65s.mp4'
   
    }
  ];
  

  const incidents = entityDetails?.name === 'CAM-091' ? bbIncidentData : glIncidentData 

  // Mock crowd count for last 24 hours - different patterns for each camera
  const getGreatLawnCrowdData = () => [
    { time: '00:00', count: 2 },
    { time: '01:00', count: 1 },
    { time: '02:00', count: 1 },
    { time: '03:00', count: 0 },
    { time: '04:00', count: 1 },
    { time: '05:00', count: 3 },
    { time: '06:00', count: 8 },
    { time: '07:00', count: 25 }, // Morning peak starts
    { time: '08:00', count: 45 }, // Morning peak
    { time: '09:00', count: 38 }, // Morning peak ends
    { time: '10:00', count: 22 },
    { time: '11:00', count: 18 },
    { time: '12:00', count: 15 },
    { time: '13:00', count: 12 },
    { time: '14:00', count: 14 },
    { time: '15:00', count: 20 },
    { time: '16:00', count: 28 },
    { time: '17:00', count: 42 }, // Evening peak starts
    { time: '18:00', count: 50 }, // Evening peak
    { time: '19:00', count: 35 }, // Evening peak ends
    { time: '20:00', count: 18 },
    { time: '21:00', count: 8 },
    { time: '22:00', count: 4 },
    { time: '23:00', count: 2 }
  ];

  const getBarkBarCrowdData = () => [
    { time: '00:00', count: 8 }, // Late night crowd
    { time: '01:00', count: 5 },
    { time: '02:00', count: 2 },
    { time: '03:00', count: 1 },
    { time: '04:00', count: 1 },
    { time: '05:00', count: 2 },
    { time: '06:00', count: 3 },
    { time: '07:00', count: 5 },
    { time: '08:00', count: 8 },
    { time: '09:00', count: 12 },
    { time: '10:00', count: 15 },
    { time: '11:00', count: 18 },
    { time: '12:00', count: 25 }, // Lunch crowd
    { time: '13:00', count: 22 },
    { time: '14:00', count: 18 },
    { time: '15:00', count: 20 },
    { time: '16:00', count: 25 },
    { time: '17:00', count: 32 },
    { time: '18:00', count: 45 }, // Evening crowd starts
    { time: '19:00', count: 55 }, // Peak evening
    { time: '20:00', count: 62 }, // Peak evening
    { time: '21:00', count: 58 }, // Night crowd
    { time: '22:00', count: 48 }, // Night crowd
    { time: '23:00', count: 35 }  // Late night starts
  ];

  const crowd24h = entityDetails?.crowd24h || 
    (entityDetails?.name === 'CAM-091' ? getBarkBarCrowdData() : getGreatLawnCrowdData());

  const crowdChartRef = useRef(null);

  useEffect(() => {
    if (crowdChartRef.current && crowd24h.length > 0) {
      renderCrowdChart();
    }
  }, [crowd24h]);

  const renderCrowdChart = () => {
    d3.select(crowdChartRef.current).selectAll('*').remove();

    const width = 400;
    const height = 300;
    const margin = { top: 20, right: 20, bottom: 60, left: 60 };
    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const svg = d3.select(crowdChartRef.current)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`);

    const data = crowd24h;

    const xScale = d3.scaleBand()
      .domain(data.map(d => d.time))
      .range([0, chartWidth])
      .padding(0.1);

    const yScale = d3.scaleLinear()
      .domain([0, d3.max(data, d => d.count)])
      .nice()
      .range([chartHeight, 0]);

    svg.append('g')
      .attr('transform', `translate(0, ${chartHeight})`)
      .call(d3.axisBottom(xScale))
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
      .style('font-size', '10px');

    svg.append('g')
      .call(d3.axisLeft(yScale))
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', -40)
      .attr('x', -chartHeight / 2)
      .attr('text-anchor', 'middle')
      .text('People Count')
      .style('font-size', '12px');

    const line = d3.line()
      .x(d => xScale(d.time) + xScale.bandwidth() / 2)
      .y(d => yScale(d.count));

    svg.append('path')
      .datum(data)
      .attr('fill', 'none')
      .attr('stroke', '#2E7D32')
      .attr('stroke-width', 3)
      .attr('d', line);

    const tooltip = d3.select(crowdChartRef.current)
      .append('div')
      .attr('class', 'tooltip')
      .style('opacity', 0)
      .style('position', 'absolute')
      .style('background', 'rgba(0, 0, 0, 0.8)')
      .style('color', 'white')
      .style('padding', '8px')
      .style('border-radius', '4px')
      .style('font-size', '12px')
      .style('pointer-events', 'none');

    svg.selectAll('.crowd-dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'crowd-dot')
      .attr('cx', d => xScale(d.time) + xScale.bandwidth() / 2)
      .attr('cy', d => yScale(d.count))
      .attr('r', 4)
      .attr('fill', '#2E7D32')
      .style('cursor', 'pointer')
      .on('mouseover', function(event, d) {
        d3.select(this).attr('r', 6);
        tooltip.transition().duration(200).style('opacity', 0.9);
        tooltip.html(`<strong>${d.time}</strong><br/>Count: ${d.count}`)
          .style('left', (event.pageX + 10) + 'px')
          .style('top', (event.pageY - 28) + 'px');
      })
      .on('mouseout', function() {
        d3.select(this).attr('r', 4);
        tooltip.transition().duration(300).style('opacity', 0);
      });

    svg.append('text')
      .attr('x', chartWidth / 2)
      .attr('y', -5)
      .attr('text-anchor', 'middle')
      .style('font-size', '14px')
      .style('font-weight', 'bold')
      .text('Crowd Count - Last 24 Hours');
  };

  return (
    <>
      {/* Live Preview */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
            <VideocamOutlinedIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Live Preview</Typography>
          </Box>
          {liveStreamUrl ? (
            <Box
              component="video"
              src={liveStreamUrl}
              poster={livePosterUrl}
              controls
              muted
              autoPlay
              playsInline
              sx={{
                width: '100%',
                maxHeight: 280,
                backgroundColor: '#000',
                borderRadius: 1,
                border: '1px solid #e0e0e0'
              }}
            />
          ) : (
            <Box
              component="img"
              src={livePosterUrl}
              alt={entityDetails?.image?.fileName || 'Camera Preview'}
              sx={{
                width: '100%',
                height: 'auto',
                maxHeight: 280,
                objectFit: 'cover',
                backgroundColor: '#000',
                borderRadius: 1,
                border: '1px solid #e0e0e0'
              }}
            />
          )}
        </CardContent>
      </Card>

      {/* Detected Events */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
            <ReportGmailerrorredOutlinedIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Detected Events</Typography>
          </Box>

          {incidents && incidents.length > 0 ? (
            <List disablePadding>
              {incidents.map((evt, idx) => (
                <Accordion key={evt.id || idx} disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Box display="flex" alignItems="center" sx={{ width: '100%', gap: 1 }}>
                      <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
                        {evt.title}
                      </Typography>
                      <Chip 
                        label={evt.severity}
                        size="small"
                        color={
                          evt.severity === 'High' ? 'error' : evt.severity === 'Medium' ? 'warning' : 'default'
                        }
                        variant="outlined"
                      />
                      <Typography variant="caption" color="textSecondary">
                        {evt.time ? new Date(evt.time).toLocaleString() : ''}
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                      {evt.description}
                    </Typography>
                    {evt.videoUrl ? (
                      <Box
                        component="video"
                        src={evt.videoUrl}
                        poster={evt.thumbnailUrl || livePosterUrl}
                        controls
                        playsInline
                        sx={{
                          width: '100%',
                          maxHeight: 260,
                          backgroundColor: '#000',
                          borderRadius: 1,
                          border: '1px solid #e0e0e0'
                        }}
                      />
                    ) : (
                      <Typography variant="caption" color="textSecondary">
                        No video available for this event.
                      </Typography>
                    )}
                  </AccordionDetails>
                  {idx < incidents.length - 1 && <Divider />}
                </Accordion>
              ))}
            </List>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No detected events.
            </Typography>
          )}
        </CardContent>
      </Card>

      {/* Crowd Count Chart */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
            <GroupsOutlinedIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Crowd Count (24 Hours)</Typography>
          </Box>
          <Box
            ref={crowdChartRef}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '320px'
            }}
          />
        </CardContent>
      </Card>
    </>
  );
};

export default CameraEntityDrawer;


